import * as React from "react";
import styled from "../../../styled/index";
import { RestaurantIcon, RestaurantIconList } from "../../elements/restaurant.icon/index";
import { CS } from "../../../styles/index";
const Wrapper = styled("div") `
  display: flex;
  flex-wrap: wrap;
`;
const Icon = styled("div") `
  ${CS.flex.center};
  width: 50px;
  height: 50px;
  border: 1px solid ${({ theme }) => theme.input.border};
  cursor: pointer;
  font-size: 32px;
  &:hover, &.active {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary_text};
  }
`;
export const RestaurantIconSelect = (props) => (React.createElement(Wrapper, null, Object.keys(RestaurantIconList).map((key) => (React.createElement(Icon, { key: key, onClick: () => props.onChange(key), className: props.selected === key ? "active" : "" },
    React.createElement(RestaurantIcon, { icon: key }))))));
//# sourceMappingURL=index.js.map